import {scenarioTriggers} from "./scenarioTriggers";
import {
    AlarmCenterIcon,
    AlarmIcon, AppIdleIcon,
    AssistanceRequestIcon, BatteryAlertIcon, BatteryChargingIcon, BatteryIcon, BeaconAgeIcon, BuildingIcon,
    ButtonIcon, ConfigIcon, EmailIcon, IOIcon, LocationEnterIcon, LocationExitIcon,
    RipcordIcon, ScenarioIcon, ScheduleIcon, SendIcon, SMSIcon,
    TimeToAlarmIcon, TimerIcon, WebhookIcon,
    WifiStarIcon,
    WithoutAlarmIcon,
    AppPermissionsIncorrectIcon
} from "../../icons";
import ManDownIcon from "../../../components/Icon/ManDownIcon";

export const triggerIcons = {
    [scenarioTriggers.allAlarmTypes]: AlarmIcon,
    [scenarioTriggers.genericAlarm]: AlarmIcon,
    [scenarioTriggers.manDown]: ManDownIcon,
    [scenarioTriggers.sosButton]: AlarmIcon,
    [scenarioTriggers.ripcord]: RipcordIcon,
    [scenarioTriggers.timer]: TimerIcon,
    [scenarioTriggers.alarmClosed]: WithoutAlarmIcon,
    [scenarioTriggers.assistanceRequestClosed]: AssistanceRequestIcon,
    [scenarioTriggers.connectionChanged]: WifiStarIcon,
    [scenarioTriggers.quickButton]: ButtonIcon,
    [scenarioTriggers.beaconBattery]: BatteryAlertIcon,
    [scenarioTriggers.geofenceEntered]: LocationEnterIcon,
    [scenarioTriggers.geofenceExited]: LocationExitIcon,
    [scenarioTriggers.geofenceAttendance]: LocationExitIcon,
    [scenarioTriggers.docked]: BatteryChargingIcon,
    [scenarioTriggers.undocked]: BatteryIcon,
    [scenarioTriggers.lowBattery]: BatteryAlertIcon,
    [scenarioTriggers.smsMessage]: SMSIcon,
    [scenarioTriggers.webhook]: WebhookIcon,
    [scenarioTriggers.ioChange]: IOIcon,
    [scenarioTriggers.espa]: IOIcon,
    [scenarioTriggers.email]: EmailIcon,
    [scenarioTriggers.configError]: ConfigIcon,
    [scenarioTriggers.multiTenant]: BuildingIcon,
    [scenarioTriggers.messageNotAcknowledged]: SendIcon,
    [scenarioTriggers.checkAssistanceRequestResponses]: AssistanceRequestIcon,
    [scenarioTriggers.arcAlarm]: AlarmCenterIcon,
    [scenarioTriggers.scenarioDisabled]: ScenarioIcon,
    [scenarioTriggers.beaconAge]: BeaconAgeIcon,
    [scenarioTriggers.appIdle]: AppIdleIcon,
    [scenarioTriggers.schedule]: ScheduleIcon,
    [scenarioTriggers.appPermissionsIncorrect]: AppPermissionsIncorrectIcon,
    [scenarioTriggers.noAlarmInPeriod]: TimeToAlarmIcon,
    [scenarioTriggers.noBeaconInPeriod]: BeaconAgeIcon
};